import RemoveFeatureUpdateModal from './RemoveFeatureUpdateModal';

export default RemoveFeatureUpdateModal;
